import { Asset, useTags } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// The router's HeadContent uses the deepest route title as-is and has no title
// template, so the brand suffix is added here.
export function HeadContent() {
  const { t } = useTranslation(["general"]);
  const tags = useTags();
  const brand = t("general:documentTitle.default");
  const page = tags.find((tag) => tag.tag === "title")?.children;

  return (
    <>
      {tags
        .filter((tag) => tag.tag !== "title")
        .map((tag) => (
          <Asset key={JSON.stringify(tag)} {...tag} />
        ))}
      <title>{page ? `${page} | ${brand}` : brand}</title>
    </>
  );
}
